import React from "react";
import TableInfoCell from "./TableInfoCell";
import { useSearchParams } from "react-router-dom";

function TableInfoRow(props) {
  const { tableConfig, rowData } = props;

  const [searchParams] = useSearchParams();
  const contractId = searchParams.get("contractId")
  const getHighlight = (cellConfig, index) => {
    switch (cellConfig?.dataKey) {
      case 'contract_id':
        return contractId && contractId === rowData.item?._id;
    }
    return false;
  }

  return (
    <div className="w-full h-[52px] flex">
      {Array.isArray(tableConfig)
        ? tableConfig.map((cellConfig, index) => {
          const highlight = getHighlight(cellConfig, index)
            return cellConfig.CustomTableCell ? (
              <cellConfig.CustomTableCell
                key={index}
                width={cellConfig.width}
                textAlign={cellConfig.textAlign}
                cellContent={
                  rowData?.[cellConfig.dataKey] !== undefined
                    ? rowData?.[cellConfig.dataKey]
                    : ""
                }
                highlight={highlight}
                {...cellConfig}
              />
            ) : (
              <TableInfoCell
                key={index}
                width={cellConfig.width}
                textAlign={cellConfig.textAlign}
                cellClass={cellConfig?.cellClass}
                cellContent={
                  rowData?.[cellConfig.dataKey] !== undefined
                    ? rowData?.[cellConfig.dataKey]
                    : ""
                }
                highlight={highlight}
              />
            );
          })
        : null}
    </div>
  );
}

export default TableInfoRow;
